<template>
  <section>
    <div class="section_title">
      <img src="@/assets/img/cart_sub.jpg" />
      <h1 class="">ご注文</h1>
    </div>
    <h2 class="mb-0 mt-2 text-left">1. カートを確認</h2>
    <div class="form-navi my-5">
      <ul class="d-flex flex-wrap">
        <li class="here px-3">1.カートを確認</li>
        <li class="px-3">2.お届け先の選択</li>
        <li class="px-3">3.お支払い方法の選択</li>
        <li class="px-3">4.最終確認</li>
      </ul>
    </div>
    <div class="detail-cart border box-p-20">
      <div class="d-flex py-3 border-bottom only_pc">
        <div class="shohin_group text-center"><p>商品</p></div>
        <div class="shohin_quantity text-center"><p>個数</p></div>
        <div class="shohin_price text-center"><p>価格</p></div>
      </div>
      <div id="CartList">
        <ul>
          <CartDetailItem
            v-for="(item, idx) in cartItems"
            :key="item.code"
            :no="idx + 1"
            :itemNo="item.no"
            :optionCount="item.optionCount"
            :itemCount="item.itemCount"
            :name="item.name"
            :type="item.type"
            :code="item.code"
            :price="item.price"
            @loadCart="loadCart"
          />
        </ul>
      </div>
      <!-- 動的HTML生成部 カート小計 -->
      <div id="CartSubtotal" class="d-flex my-3">
        <div class="shohin_price_all text-right"><p>小計</p></div>
        <div class="shohin_price text-right">
          <p>{{ subtotal }}円</p>
        </div>
      </div>
      <div v-if="!isProxy" id="" class="d-flex my-3">
        <div class="shohin_price_all text-right"><p>付与予定ポイント</p></div>
        <div class="shohin_price text-right">
          <p>{{WillbeCollectedPoint}}ポイント</p>
        </div>
      </div>
      <div class="text-center pt-5">
        <router-link to="/products" class="btn d-inline-block"
          >他の商品を追加する</router-link
        >
      </div>
    </div>
    <div class="box-p-20 text-center" v-show="!message">
      <router-link to="/cart/delivery" class="btn d-inline-block"
        >お届け先の住所選択へ進む</router-link
      >
    </div>
  </section>
</template>

<script>
import Message from "@/modules/Message";
import Store from "@/modules/Store";
import CartDetailItem from "./components/CartDetailItem";
import Request from "@/modules/Request";
let request = new Request();
let store = new Store();

export default {
  components: {
    CartDetailItem,
  },
  mounted() {
    this.loadCart();
    if(store.get('isProxy') == 1){
      this.isProxy = true;
    }
    window.scroll(0, 0);
  },
  data() {
    return {
      subtotal: 0,
      cartItems: [],
      message: "",
      WillbeCollectedPoint:0,
      isProxy:false
    };
  },
  methods: {
    loadCart() {
      let postParams = [];
      let requestParams = request.createParams(
        "webMdlCart",
        "getSubtotal",
        postParams
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.cartItems = data.cartItems;
          this.subtotal = data.CartSubtotal;
          this.message = data.message;
          this.limit = data.PossibleQuantity;
          this.WillbeCollectedPoint = data.WillbeCollectedPoint;
          let PossessionPoint= data.PossessionPoint;
          store.set("PossessionPoint", PossessionPoint);
          store.set("WillbeCollectedPoint", this.WillbeCollectedPoint);

          if (this.message) {
            Message.error().fire({
              title: this.message,
            });
          }
        });
    },
  },
};
</script>